// AUTO-GENERATED SEED — review before trusting. Rename keys (index→list/detail),
// refine params, confirm caller flags, add opt-in response types.
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
// Type-only import (erased at build) — keeps the registry client-bundle-safe.
import type { PaymentInstrumentDto } from '../../schemas/responses/payment-instrument';

export const payment_instruments = defineAdminRoute({
    path: '/api/payment-instruments',
    params: {},
    // Response DTO carrier (ADR 027 / BL-855): GET lists a customer's saved
    // display-only instruments; the client infers PaymentInstrumentDto[] with no
    // <T>, and `respond()` type-checks the route against this same declaration.
    //
    // BL-1833: the `customerId` query param names the gated customer. The gate
    // resolves it before the grant, and a missing, archived or foreign customer
    // is its 404 — so the route is no "does this customer exist" oracle.
    methods: {
      GET: {
        grant: 'payment.read',
        tenant: { from: 'record', table: 'customer', param: 'customerId', in: 'query' },
        response: responseType<PaymentInstrumentDto[]>(),
      },
    },
  });
